import { AxiosResponse } from 'axios';
import { api } from 'src/common/utils';

import { AlarmRuleType, PaginatedResponseType, SlackChannelType } from './types';

export const fetchSlackChannels = (): Promise<AxiosResponse<SlackChannelType[]>> =>
  api.get('/slack_channels');

export const fetchAlarmRules = (
  accountId: string
): Promise<AxiosResponse<PaginatedResponseType<AlarmRuleType>>> =>
  api.get(`/account_alarm_rules?account=${accountId}`);

export const createAlarmRule = (
  payload: Partial<AlarmRuleType>
): Promise<AxiosResponse<AlarmRuleType>> => api.post('/account_alarm_rules', payload);

export const updateAlarmRule = (
  id: string,
  payload: Partial<AlarmRuleType>
): Promise<AxiosResponse<AlarmRuleType>> => api.patch(`/account_alarm_rules/${id}`, payload);

export const deleteAlarmRule = (id: string): Promise<AxiosResponse> =>
  api.delete(`/account_alarm_rules/${id}`);
